export default [
  `${process.env.VUE_APP_BASE_URL}/css/style.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-05.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-06.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-07.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-08.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-09.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-10.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-11.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-21.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-22.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-23.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-24.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-25.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-26.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-27.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-28.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-29.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-31.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-32.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-33.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-34.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-35.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-36.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-37.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-38.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-39.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-40.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bar/bar-41.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/bat/bat1-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bat/bat1-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bat/bat2-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bat/bat2-02.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-05.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-06.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-07.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-08.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-09.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bes/bes-10.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-05.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-06.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-07.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-08.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-09.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-10.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bpm/bpm-11.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/bsc/bsc-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bsc/bsc-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/bsc/bsc-03.css`,

  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtm/jtm-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtm/jtm-02.css`,

  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtc/jtc-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtc/jtc-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtc/jtc-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jtc/jtc-04.css`,

  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jes/jes-01_jse-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jes/jes-02_jse-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jes/jes-03_jse-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jes/jes-04_jse-02.css`,

  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb4-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb4-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb4-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb4-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb5-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb5-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb6-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb6-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb7-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb7-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb8-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb8-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb8-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb9-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb9-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb9-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb10-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb10-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb10-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb10-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb11-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb11-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb11-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb11-04.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb12-01.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb12-02.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb12-03.css`,
  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jrb/jrb13-01.css`,

  `${process.env.VUE_APP_BASE_URL}/css/jusetsu/jle/jle-01.css`,

  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/urinushi_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/kainushi_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/tochi_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/shakuchiken_tochi_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/tokuyaku_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/jiko_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/teikishakuchiken_tochi_besshi.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/tochi_bes08.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/tochi_bes10.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/jtm/sub-jtm.css`,
  `${process.env.VUE_APP_BASE_URL}/css/baikei/besshi/wakaregyoshajoho2_besshi.css`
]
